import Vue from 'vue';

let VueEvents = window.VueEvents || (window.VueEvents = new Vue({ name: "VueEvents" }));

export default VueEvents;



// WEBPACK FOOTER //
// ./src/vues/vue-events.js